<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="免费领取码" prop="claimCode">
              <el-input v-model="searchForm.claimCode" placeholder="请输入免费领取码" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-form-item label="使用学员" prop="useStudentId">
              <el-input type="number" v-model="searchForm.useStudentName" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="核销时间" prop="userTime">
              <el-date-picker
                v-model="searchForm.userTimeScopeList"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="24" :lg="12">
            <el-form-item label="创建时间" prop="userTime">
              <el-date-picker
                v-model="searchForm.createTimeScopeList"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :sm="24" :md="12" :lg="6">
            <el-button type="primary" @click="pageList" icon="el-icon-search">搜索</el-button>
            <el-button type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
        <el-button type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button style="text-align: right" type="primary" @click="exportExcel" :loading="loading" icon="el-icon-upload2">导出</el-button>
        </el-col>
      </el-row>
      <el-table ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;"
                height="520" border @selection-change="selectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="claimCode" label="兑换码" ></el-table-column>
        <el-table-column prop="endDate" label="有效结束时间"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="operatorName" label="操作人"></el-table-column>
        <el-table-column prop="useStudentName" label="使用学员"></el-table-column>
        <el-table-column prop="userTime" label="核销时间"></el-table-column>
<!--        <el-table-column prop="" label="操作" width="180" align="center">-->
<!--          <template slot-scope="scope">-->
<!--            <div class="operationGroup">-->
<!--              <span @click="selection = scope.row.id, editFormVisible = true">编辑</span>-->
<!--              <span @click="deleteGoodsClaimCode(scope.row)">删除</span>-->
<!--            </div>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination background layout="prev, pager, next" style="margin-top: 20px;text-align: right;"
                     :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber"
                     @size-change="sizeChange" @current-change="currentChange">
      </el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" width="50%" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="生成数量" prop="createClaimCodeNum">
          <el-input v-model="addForm.createClaimCodeNum" placeholder="请输入生成数量" auto-complete="off" maxlength="255"></el-input>
        </el-form-item>
         </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGoodsClaimCode">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" width="50%" left>
      <el-form ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="editFormRules">
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="" prop="id" v-show="false">
          <el-input type="hidden" v-model="editForm.id" auto-complete="off" maxlength="19"></el-input>
        </el-form-item>
         </el-col>
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="" prop="id">
          <el-input type="number" v-model="editForm.id" placeholder="请输入" auto-complete="off" maxlength="19"></el-input>
        </el-form-item>
         </el-col>
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="机构id" prop="agentId">
          <el-input type="number" v-model="editForm.agentId" placeholder="请输入机构id" auto-complete="off" maxlength="19"></el-input>
        </el-form-item>
         </el-col>
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="绑定商品id" prop="goodsId">
          <el-input type="number" v-model="editForm.goodsId" placeholder="请输入绑定商品id" auto-complete="off" maxlength="19"></el-input>
        </el-form-item>
         </el-col>
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="免费领取码" prop="claimCode">
          <el-input v-model="editForm.claimCode" placeholder="请输入免费领取码" auto-complete="off" maxlength="255"></el-input>
        </el-form-item>
         </el-col>
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="操作人" prop="operatorId">
          <el-input type="number" v-model="editForm.operatorId" placeholder="请输入操作人" auto-complete="off" maxlength="19"></el-input>
        </el-form-item>
         </el-col>
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="状态:1-正常 -1删除" prop="state">
          <el-input type="number" v-model="editForm.state" placeholder="请输入状态:1-正常 -1删除" auto-complete="off" maxlength="10"></el-input>
        </el-form-item>
         </el-col>
        <el-col :sm="24" :md="12" :lg="12">
        <el-form-item label="使用学员id" prop="useStudentId">
          <el-input type="number" v-model="editForm.useStudentId" placeholder="请输入使用学员id" auto-complete="off" maxlength="19"></el-input>
        </el-form-item>
         </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updateGoodsClaimCode">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        goodsClaimCodeFormGoodsId:this.$route.query.goodsClaimCodeFormGoodsId,
        page: {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
          sortName: '',
          sortOrder: ''
        },
        addFormVisible: false,
        editFormVisible: false,
        importFormVisible: false,
        searchForm: {
          id: '',
          agentId: '',
          goodsId: '',
          claimCode: '',
          beginDate: '',
          endDate: '',
          createTime: '',
          updateTime: '',
          operatorId: '',
          state: '',
          useStudentId: '',
          userTime: '',
          // userTimeScopeList:[]
        },
        addForm: {
          createClaimCodeNum:null,//自动生成个数
          id: '',
          agentId: '',
          goodsId: '',
          claimCode: '',
          endDate: '',
          beginDate: '',
          createTime: '',
          updateTime: '',
          operatorId: '',
          state: '',
          useStudentId: '',
          userTime: '',
        },
        addFormRules: {
          createClaimCodeNum: [{
            required: true,
            message: '请输入生成数量',
            trigger: 'blur'
          }, {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: '输入生成数量格式不正确'
          }],
        },
        editForm: {
          id: '',
          agentId: '',
          goodsId: '',
          claimCode: '',
          endDate: '',
          beginDate: '',
          createTime: '',
          updateTime: '',
          operatorId: '',
          state: '',
          useStudentId: '',
          userTime: '',
        },
        editFormRules: {
          id: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }, {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: '格式不正确'
          }],
          agentId: [{
            required: true,
            message: '请输入机构id',
            trigger: 'blur'
          }, {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: '机构id格式不正确'
          }],
          goodsId: [{
            required: true,
            message: '请输入绑定商品id',
            trigger: 'blur'
          }, {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: '绑定商品id格式不正确'
          }],
          claimCode: [{
            required: true,
            message: '请输入免费领取码',
            trigger: 'blur'
          }, {
            min: 1,
            max: 255,
            message: '免费领取码长度在1到255个字'
          }],
          operatorId: [{
            required: true,
            message: '请输入操作人',
            trigger: 'blur'
          }, {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: '操作人格式不正确'
          }],
          state: [{
            required: true,
            message: '请输入状态:1-正常 -1删除',
            trigger: 'blur'
          }, {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: '状态:1-正常 -1删除格式不正确'
          }],
          useStudentId: [{
            required: true,
            message: '请输入使用学员id',
            trigger: 'blur'
          }, {
            pattern: /^[+-]?([0-9]*\.?[0-9]+|[0-9]+\.?[0-9]*)([eE][+-]?[0-9]+)?$/,
            message: '使用学员id格式不正确'
          }],
        },
        importForm: {},
        formLabelWidth: '80px',
        selection: '',
        multipleSelection: '',
        ids: [],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        fileAction: `${process.env.BASE_URL}/goodsClaimCode/upload`,
        fileList: [],
        loading: false,
      };
    },
    methods: {
      sizeChange(pageSize) {
        this.page.pageSize = pageSize
        this.pageList()
      },
      currentChange(pageNumber) {
        this.page.pageNumber = pageNumber
        this.pageList()
      },
      selectionChange(val) {
        this.multipleSelection = val;
        val.map(e => this.ids.push({id: e.id}))
      },
      getGoodsClaimCode() {
        this.api.goodsClaimCode.getGoodsClaimCode({
          id: this.selection
        }).then(result => {
          this.editForm = result.data;
        }).catch(error => {
          console.log(error)
        })
      },
      pageList() {
        this.searchForm.pageSize = this.page.pageSize;
        this.searchForm.pageNumber = this.page.pageNumber;
        this.searchForm.sortName = this.page.sortName;
        this.searchForm.sortOrder = this.page.sortOrder;
        this.api.goodsClaimCode.pageList(this.searchForm).then(result => {
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        }).catch(error => {
          console.log(error)
        })
      },
      addGoodsClaimCode() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            if(this.addForm.createClaimCodeNum > 1000){
              this.$message.error("生成数量不能大于1000")
              return ;
            }
            this.api.goodsClaimCode.addGoodsClaimCode(this.addForm).then(result => {
              if(result.success) {
                this.$message({
                  type: 'success',
                  message: result.message
                });
                this.addFormVisible = false;
                this.pageList();
              }else {
                this.$message.error(result.message);
              }
            }).catch(error => {
              console.log(error)
            })
          } else {
            return false;
          }
        })
      },
      updateGoodsClaimCode() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.api.goodsClaimCode.updateGoodsClaimCode(this.editForm).then(result => {
              if(result.success) {
                this.$message({
                  type: 'success',
                  message: result.message
                });
                this.editFormVisible = false;
                this.pageList();
              }else {
                this.$message.error(result.message);
              }
            }).catch(error => {
              console.log(error)
            })
          } else {
            return false;
          }
        })
      },
      deleteGoodsClaimCode(row) {
        this.$confirm('您确定要进行删除操作吗？', '系统消息', {
          type: 'warning'
        }).then(()=> {
          this.api.goodsClaimCode.deleteGoodsClaimCode([{
            id: row.id
          }]).then(result => {
            if(result.success) {
              this.$message({
                type: 'success',
                message: result.message
              });
              this.pageList();
            }else {
              this.$message.error(result.message);
            }
          }).catch(error => {
            console.log(error)
          })
        }).catch(() => {

        });
      },
      batchDeleteGoodsClaimCode() {
        this.$confirm('您确定要进行删除操作吗？', '系统消息', {
          type: 'warning'
        }).then(()=> {
          this.api.goodsClaimCode.deleteGoodsClaimCode(this.ids).then(result => {
            if(result.success) {
              this.$message({
                type: 'success',
                message: result.message
              });
              this.pageList();
            }else {
              this.$message.error(result.message);
            }
          }).catch(error => {
            console.log(error)
          })
        }).catch(() => {

        });
      },
      reset() {
        this.$refs.searchForm.resetFields();
      },
      handleSuccess (response, file, fileList, $event) {
        this.importForm = response.data;
      },
      exportExcel() {
        this.loading = true;
        this.api.goodsClaimCode.exportExcel(this.searchForm).then(result => {
          location.href = result.data;
          this.loading = false;
        }).catch(error => {
          console.log(error)
        })
      },
      importData() {
        this.api.goodsClaimCode.importData(this.importForm.rows).then(result => {
          this.$message({
            type: 'success',
            message: result.message
          });
          this.pageList()
          this.importFormVisible = false;
        }).catch(error => {
          console.log(error)
        })
      },
    },
    computed: {
      reqData() {
        return this.$store.state.user;
      }
    },
    watch: {
      'addFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.addForm.resetFields();
          this.pageList()
        } else {

        }
      },
      'editFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.editForm.resetFields();
          this.pageList()
        } else {
          this.getGoodsClaimCode()
        }
      }
    },
    mounted() {
      this.searchForm.goodsId = this.goodsClaimCodeFormGoodsId;
      this.addForm.goodsId = this.goodsClaimCodeFormGoodsId;
      this.pageList()
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/goodsClaimCode/index.vue